import { render, staticRenderFns } from "./OrderProductDialogue.vue?vue&type=template&id=013e8bcf&"
import script from "./OrderProductDialogue.vue?vue&type=script&lang=ts&"
export * from "./OrderProductDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports